
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import cardTips from "@/components/card-tips/card-tips.vue";
import {
  getByMchIdCustomerId,
  readCard,
  getCardSerialNumber,
  cancelCard
} from "@/api/api-operation-service";
import websocketFn from "@/views/member-management/non-real-name-card-management/children/js/WebSocket";
import i18n from "@/config/i18n";
@Component({
  components: {
    "card-tips": cardTips
  }
})
export default class PiBindCard extends Vue {
  private newCarForm: objAny = {};
  private loadingSuccess = false;
  private destroyedCardBox = false;
  private cardPkId = "";
  private destroyedForm: objAny = {
    remark: ""
  };
  private rules = {
    remark: [
      {
        required: true,
        message: i18n.t("nonRealNameCardManagement.remarkPl"),
        trigger: "blur"
      }
    ]
  };
  private loading = false;
  private orgCode = "";
  private callface = {
    getCard: "/readCard",
    change: "/depositCard",
    debitCard: "/debitCard",
    issueCard: "/issueCard",
    unlockCard: "/unlockCard",
    clearCard: "/clearCard",
    registryCard: "/registryCard",
    setBalance: "/setBalance",
    getVersion: "/getVersion"
  };
  private opencarId = "";
  private callfaceIndex: objAny = {};
  private loadingList: objAny = {
    getLoading: false,
    openLoading: false,
    changeLoading: false,
    unlockLoading: false,
    infoLoading: false,
    registryLoading: false,
    destroyedLoading: false,
    updataMoneyLoading: false
  };

  async init(): Promise<void> {
    const ret = await getByMchIdCustomerId({});
    if (ret.status === this.$config.apiStatus) {
      this.orgCode = ret.data[0].issueCardCodeRet;
      this.loading = true;
      websocketFn.initSocket({
        onopen: this.onopen,
        onmessage: this.onmessage,
        onerror: this.onerror
      });
    }
  }

  onopen(): void {
    this.loadingSuccess = true;
    this.loading = false;
    this.$emit("loadingSuccess", true);
  }
  onmessage(data: objAny): void {
    // console.log('收到消息')
    console.log(data);
    if (data.result === "ok") {
      switch (data.callface) {
        case this.callface.getCard:
          this.getCardInfo(data.rfif);
          break;
        case this.callface.issueCard:
          this.openCardSuccess(data.rfif);
          break;

        case this.callface.clearCard:
          this.destroyedCardSuccess();
          break;
      }
      this.callfaceIndex[data.callface].index = 0;
    } else {
      if (this.callfaceIndex[data.callface].index < 3) {
        this.callfaceIndex[data.callface].call();
      } else {
        for (const i in this.loadingList) {
          this.loadingList[i] = false;
        }
        this.callfaceIndex[data.callface].index = 0;

        if (data.status === 8 || data.status === 9) {
          this.changeError();
        } else {
          let message = "";
          switch (data.status) {
            case 1:
              message = i18n.t("nonRealNameCardManagement.statusError1") + "";
              break;
            case 2:
              message = i18n.t("nonRealNameCardManagement.statusError2") + "";
              break;
            case 3:
              message = i18n.t("nonRealNameCardManagement.statusError3") + "";
              break;
            case 4:
              message = i18n.t("nonRealNameCardManagement.statusError4") + "";
              break;
            case 5:
              message = i18n.t("nonRealNameCardManagement.statusError5") + "";
              break;
            case 6:
              message = i18n.t("nonRealNameCardManagement.statusError6") + "";
              break;
            case 7:
              message = i18n.t("nonRealNameCardManagement.statusError7") + "";
              break;
            // case 8:
            //   message = "不能充值到其它卡";
            //   break;
            // case 9:
            //   message = "不能扣款到其它卡";
            //   break;
            // case 10:
            //   message = "不能解锁其它卡";
            //   break;
            // case 11:
            //   message = "不能修改金额到其它卡";
            //   break;
            default:
              message = data.result;
              break;
          }
          this.$Notice.error({
            title: i18n.t("tips") + "",
            desc: message
          });
          this.$emit("error");
        }
      }
    }
  }

  async getCardInfo(str: string): Promise<void> {
    const ret = await readCard({ aes: str });

    if (ret.status === this.$config.apiStatus) {
      const data = ret.data[0];
      if (data) {
        this.$emit("getSuccess", data);
      } else {
        this.$Notice.error({
          title: i18n.t("tips") + "",
          desc: i18n.t("nonRealNameCardManagement.cardWhite") + ""
        });
        this.$emit("getSuccess");
      }
    } else {
      this.$emit("getSuccess");
    }
    this.loadingList.getLoading = false;
  }
  changeError(): void {
    this.$Notice.error({
      title: i18n.t("tips") + "",
      desc: i18n.t("nonRealNameCardManagement.cardChange") + ""
    });
  }
  onerror(type: string): void {
    this.loadingSuccess = false;
    this.$emit("loadingSuccess", false);
    if (type) {
      this.loading = false;
    }
  }

  getCard(): void {
    this.keyIndex(this.callface.getCard, 0, this.getCard);
    this.loadingList.getLoading = true;
    websocketFn.send({
      callface: this.callface.getCard,
      param: { orgId: this.orgCode, clientNum: this.orgCode }
    });
  }

  keyIndex(key: string, index: number, call: any): void {
    if (!this.callfaceIndex[key]) {
      this.callfaceIndex[key] = { index: 0, call: call };
    }

    if (index || index === 0) {
      this.callfaceIndex[key].index = this.callfaceIndex[key].index + 1;
    }
  }

  async openCardSuccess(str: string): Promise<void> {
    this.$emit("openCardSuccess", str);
  }
  public resetoOpencarId(): void {
    this.opencarId = "";
  }
  async openNewCardGetIdSucess(data?: objAny): Promise<void> {
    if (data) {
      this.newCarForm = data;
    } else {
      data = this.newCarForm;
    }
    if (this.opencarId == "") {
      const ret = await getCardSerialNumber({});
      if (ret.status === this.$config.apiStatus) {
        const id = ret.data[0].cardSerialNumber;
        this.opencarId = id;
      } else {
        return;
      }
    }
    // data = this.newCarForm;
    const param: objAny = {
      silkScreen: data.silkScreen,
      name: data.name,
      phone: data.phone,
      money: data.money,
      id: this.opencarId,
      orgId: this.orgCode,
      clientNum: this.orgCode,
      cardType: data.cardType
    };
    this.loadingList.openLoading = true;
    this.keyIndex(this.callface.issueCard, 0, this.openNewCardGetIdSucess);
    websocketFn.send({ callface: this.callface.issueCard, param: param });
  }
  public destroyedClick(cardPkId: string): void {
    this.destroyedCardBox = true;
    this.cardPkId = cardPkId;
  }
  public destroyedCard(): void {
    // 销卡
    // this.clearCardFn();
    const destroyedForm: objAny = this.$refs["destroyedForm"] || {};
    destroyedForm.validate(async (valid: boolean) => {
      if (valid) {
        this.loadingList.destroyedLoading = true;
        const ret = await cancelCard({
          cardPkId: this.cardPkId,
          remark: this.destroyedForm.remark
        });
        if (ret.status === this.$config.apiStatus) {
          this.clearCardFn();
        } else {
          this.loadingList.destroyedLoading = false;
        }
      } else {
        console.log("error submit!!");
        return false;
      }
    });
  }
  clearCardFn(): void {
    this.keyIndex(this.callface.clearCard, 0, this.clearCardFn);
    websocketFn.send({ callface: this.callface.clearCard, param: {} });
  }
  async destroyedCardSuccess(): Promise<void> {
    // 销卡成功
    this.destroyedCardBox = false;
    this.$Message.success(
      i18n.t("nonRealNameCardManagement.logoutSuccess") + ""
    );
    this.$emit("destroyedCardSuccess");
    this.loadingList.destroyedLoading = false;
  }

  activated(): void {
    this.init();
  }
  destroyed(): void {
    websocketFn.close();
  }
  deactivated(): void {
    websocketFn.close();
  }
}
